import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

import { ArticleListDesktop as ArticleListDesktopMainView } from './components/article-list/main/desktop';
import { ArticleListMobile as ArticleListMobileMainView } from './components/article-list/main/mobile';
import { ArticleListDesktop as ArticleListDesktopSecondaryView } from './components/article-list/secondary/desktop';
import { ArticleListMobile as ArticleListMobileSecondaryView } from './components/article-list/secondary/mobile';
import { MAIN_ARTICLE_LIST_VIEW_TYPE, SECONDARY_ARTICLE_LIST_VIEW_TYPE } from './constants';
import type { TArticleListViewType } from './models';

type TArticleListView =
    | typeof ArticleListDesktopMainView
    | typeof ArticleListMobileMainView
    | typeof ArticleListDesktopSecondaryView
    | typeof ArticleListMobileSecondaryView;

type TArticleListConfig = {
    List: TArticleListView;
    dataTestIdPrefix: string;
    paginationBlockStylerConfig?: IStyler;
};

type TConfigArticleListView = Record<TArticleListViewType, TArticleListConfig>;
export const articleListViewDesktop: TConfigArticleListView = {
    [MAIN_ARTICLE_LIST_VIEW_TYPE]: {
        List: ArticleListDesktopMainView,
        dataTestIdPrefix: MAIN_ARTICLE_LIST_VIEW_TYPE,
    },
    [SECONDARY_ARTICLE_LIST_VIEW_TYPE]: {
        List: ArticleListDesktopSecondaryView,
        dataTestIdPrefix: SECONDARY_ARTICLE_LIST_VIEW_TYPE,
    },
};

export const articleListViewMobile: TConfigArticleListView = {
    [MAIN_ARTICLE_LIST_VIEW_TYPE]: {
        List: ArticleListMobileMainView,
        dataTestIdPrefix: MAIN_ARTICLE_LIST_VIEW_TYPE,
        paginationBlockStylerConfig: {
            marginTop: 16,
            paddingLeft: 16,
            paddingRight: 16,
        },
    },
    [SECONDARY_ARTICLE_LIST_VIEW_TYPE]: {
        List: ArticleListMobileSecondaryView,
        dataTestIdPrefix: SECONDARY_ARTICLE_LIST_VIEW_TYPE,
        paginationBlockStylerConfig: {
            marginTop: 16,
        },
    },
};
